import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Button } from '@shared/ui/button';
import { authApi } from '../../../api/services/auth.service';
import { useDispatch } from 'react-redux';
import {
  setErrorNotification,
  setNotification,
} from '../../../app/store/notifications';
import AuthLayout from '@shared/ui/access-layout';
import back from '../../../shared/assets/sprites/arrow_back.png';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  passwordResetConfirmSchema,
  passwordResetSchema,
} from '@shared/lib/validators/registration-schema';
import { InputField } from '@shared/ui/input-field';
const PasswordResetForm = () => {
  const [error, setError] = useState<string>('');
  const [status, setStatus] = useState<string>('');
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(passwordResetSchema),
    shouldUnregister: false,
    defaultValues: { email: '' },
  });

  const onSubmit = ({ email }: { email: string }) => {
    setStatus('loading');
    authApi
      .passwordResetRequest({ email })
      .then(() => {
        setStatus('confirmed');
        setError('');
      })
      .catch((err: any) => {
        setError(err?.data?.detail ? err.data.detail : err.message);
        setStatus('error');
      });
  };

  return (
    <AuthLayout>
      <div>
        <div className="absolute top-[10px] left-[10px]">
          <Link to="/login" className="flex justify-center items-center font-medium text-gray-500 hover:[filter:invert(37%)_sepia(93%)_saturate(7471%)_hue-rotate(356deg)_brightness(91%)_contrast(135%)]">
            <img src={back} alt="" />
            <span style={{ marginLeft: '10px' }}>Вход</span>
          </Link>
        </div>
      </div>
      {status === 'confirmed' ? (
        <>
          <h2 className="font-bold text-[28px] text-[#141414]">Сброс пароля</h2>
          <div className="mt-[45px] text-[#b4b4b4] text-base leading-[140%]">Инструкция отправлена на вашу почту</div>
        </>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)} className="w-[70%] relative">
          <h2 className="font-bold text-[28px] text-[#141414]">Восстановление пароля</h2>
          <div className="mt-[45px] text-[#b4b4b4] text-base leading-[140%]">Введите свой email для сброса пароля</div>
          <div className="mt-[30px]">
            <InputField inputName="email" id="email" label="Email" placeholder="Введите Email" register={register} errors={errors} />
          </div>
          {error && <p style={{ color: '#E3282A', fontSize: '14px', marginTop: '10px' }}>{error}</p>}
          <Button status={status} type="submit">Сбросить</Button>
        </form>
      )}
    </AuthLayout>
  );
};

const PasswordReset = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(passwordResetConfirmSchema),
    shouldUnregister: false,
    defaultValues: { new_password: '' },
  });

  const { key } = useParams<{ key: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Сброс пароля';
  }, []);

  const [loading, setLoading] = useState('');
  const [error, setError] = useState('');
  const dispatch = useDispatch();

  function onSubmit(data: { new_password: string }) {
    setLoading('loading');
    authApi
      .resetPassword({ code: key, new_password: data.new_password })
      .then(() => {
        setLoading('success');
        setError('');
        dispatch(setNotification('Пароль успешно сброшен'));
        navigate('/login');
      })
      .catch((err: any) => {
        setLoading('error');
        dispatch(setErrorNotification('Ошибка'));
        setError(err?.response?.data?.detail ? err.response.data.detail : 'Ошибка');
      });
  }

  return (
    <>
      {key === 'reset' ? (
        <PasswordResetForm />
      ) : (
        <AuthLayout
          leftContent={
            <section className="flex justify-center items-center flex-col absolute top-[45%] left-[25%] -translate-x-1/2 -translate-y-[20%] text-center w-[346px]">
              <h2 className="text-[28px] text-white">Сброс пароля</h2>
              <div className="my-[34px] mx-auto w-[113px] border border-white"></div>
            </section>
          }
        >
          <form className="w-[70%] relative" onSubmit={handleSubmit(onSubmit)}>
            <h2 style={{ textAlign: 'center' }} className="font-bold text-[28px] text-[#141414]">
              Подтвердите сброс пароля
            </h2>
            <InputField inputName="new_password" id="new_password" label="Новый пароль" placeholder="Введите пароль" register={register} errors={errors} />
            <Button status={loading} type="submit">Подтвердить</Button>
          </form>
          <span style={{ color: 'red' }}>{error}</span>
        </AuthLayout>
      )}
    </>
  );
};

export default PasswordReset;
